import React, { Component } from 'react';
import { Container } from 'reactstrap';
import VolCard from './volCard';

export default class Itinerarie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vols: [],
      dictionaries: [],
      isLoading: true,
      url:this.props.url,
    };
  }
  render() {
    let url = this.props.url;
    let departTbl = url.get("depart").toString().split(",")
    let arriveTbl = url.get("arrive").toString().split(",")
    
    const origin = url.get("origin");
    const destination = url.get("destination");


    const volRes = this.props.volRes;

    const vols = volRes.map((vol, i) => {
      var vOv = false;
      var horaires = [];
      var codes = [];
      var dates =[];
      let escale = {};
      let duree = [];
      var citiesName= []
      let classes = []
      let flight_no = []
      let volLine = []
      let k;
      let m =0;
      horaires.push(vol.itineraries[0][0].departTime)
      dates.push(vol.itineraries[0][0].departDate)
      codes.push(vol.itineraries[0][0].departCode)
      citiesName.push(vol.itineraries[0][0].origin)
      
      return vol.itineraries.map((itinerarie, i) => {
        (departTbl.length > 1 && arriveTbl.length > 1) ?  k = i : k = 0
        return itinerarie.map((segment, j) => {
          //if where are in the segment where arriveCode is the destination then all cities after are of the return vol
          if (segment.arriveCode === arriveTbl[k] || segment.arriveCode === departTbl[k]) {
            //destination arrive time 
            citiesName.push(segment.distination);

            horaires.push(segment.arriveTime);
            dates.push(segment.arriveDate);
            codes.push(segment.arriveCode);

            duree.push(segment.duree);
            classes.push(segment.class)
            flight_no.push(segment.flight_no)
            volLine.push(
              {
                duree:segment.duree,
                vol_class:segment.class||"",
                flight_no:segment.flight_no||"4037"
              }
            )
            
            //destination depart time Return
            if (typeof vol.itineraries[i + 1] !== "undefined") {
              horaires.push(vol.itineraries[i + 1][0].departTime);
              dates.push(vol.itineraries[i + 1][0].departDate)
              citiesName.push(vol.itineraries[i + 1][0].origin)
            }
            m ++;
          }

          //if we are still on the going vol and still didnt arrive at destination push city as escale on the going vol
          if (segment.arriveCode !== arriveTbl[k]) {
            escale[m] = (escale[m] || '')+ ',' +segment.arriveCode
          }
          //else push it as escale on return vol
          if (
            segment.arriveCode === departTbl[k] ||
            vol.itineraries.length === i + 1
          ) {
            horaires.push(segment.arriveTime); 
            dates.push(segment.arriveDate); 
            citiesName.push(segment.distination);

            return (
                <VolCard
                  key={i}
                  childKey={segment.bookingLink}
                  vol={segment}
                  horaires={horaires}
                  dates={dates}
                  arrive={arriveTbl[k] || segment.distination}
                  timeArray={horaires} //depart arrive with escales
                  codes={codes}
                  escale={escale}
                  citiesName={citiesName}
                  volLine={volLine}
                />
            );
          }
        });
      });
    });
    return  <>{vols}</>
    ;
  }
}
